module.exports = __webpack_public_path__ + "img/PIRL.530bb49c.svg";